import { AgGridReact } from 'ag-grid-react';
import { useState } from 'react';
import { ColDef } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

interface ScoreRow {
  distanceOrPar: string;
  hole1: number | string;
  hole2: number | string;
  hole3: number | string;
  hole4: number | string;
  hole5: number | string;
  hole6: number | string;
  hole7: number | string;
  hole8: number | string;
  hole9: number | string;
  front: number | string;
  hole10: number | string;
  hole11: number | string;
  hole12: number | string;
  hole13: number | string;
  hole14: number | string;
  hole15: number | string;
  hole16: number | string;
  hole17: number | string;
  hole18: number | string;
  back: number | string;
  total: number | string;
  blank1: number | string;
  blank2: number | string;
}

const ScoreCard = () => {
  const [rowData] = useState<ScoreRow[]>([
    { 
      distanceOrPar: 'Name', hole1: 1, hole2: 2, hole3: 3, hole4: 4, hole5: 5, hole6: 6, hole7: 7, hole8: 8, hole9: 9, front: "Front",
      hole10: 10, hole11: 11, hole12: 12, hole13: 13, hole14: 14, hole15: 15, hole16: 16, hole17: 17, hole18: 18, back: "Back", total: "Total", blank1:'', blank2:''
    },
  
    { 
      distanceOrPar: '', hole1: '', hole2: '', hole3: '', hole4: '', hole5: '', hole6: '', hole7: '', hole8: '', hole9: '', front: '',
      hole10: '', hole11: '', hole12: '', hole13: '', hole14: '', hole15: '', hole16: '', hole17: '', hole18: '', back: '', total: '', blank1:'', blank2:''
    },
    { 
      distanceOrPar: '', hole1: '', hole2: '', hole3: '', hole4: '', hole5: '', hole6: '', hole7: '', hole8: '', hole9: '', front: '',
      hole10: '', hole11: '', hole12: '', hole13: '', hole14: '', hole15: '', hole16: '', hole17: '', hole18: '', back: '', total: '', blank1:'', blank2:''
    },
    { 
      distanceOrPar: '', hole1: '', hole2: '', hole3: '', hole4: '', hole5: '', hole6: '', hole7: '', hole8: '', hole9: '', front: '',
      hole10: '', hole11: '', hole12: '', hole13: '', hole14: '', hole15: '', hole16: '', hole17: '', hole18: '', back: '', total: '', blank1:'', blank2:''
    },
  ]);

  const columnDefs: ColDef<ScoreRow>[] = [
    { headerName: 'Distance or Par',  field: 'distanceOrPar', pinned: 'left', minWidth: 135, width: 140, headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole1', minWidth: 60,  width: 75, valueFormatter: params => params.value === '' ? '' : params.value,  headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole2', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole3', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '4', field: 'hole4', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '5', field: 'hole5', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole6', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole7', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole8', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole9', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '30', field: 'front', minWidth: 80,  width: 100, cellStyle: { fontWeight: 'bold', borderRight: '1px solid #ccc' }, headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole10', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '4', field: 'hole11', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole12', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '4', field: 'hole13', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '5', field: 'hole14', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole15', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole16', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole17', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '3', field: 'hole18', minWidth: 60,  width: 75,  valueFormatter: params => params.value === '' ? '' : params.value , headerClass: 'border-r-2 border-black', },
    { headerName: '31', field: 'back', minWidth: 75,  width: 100, cellStyle: { fontWeight: 'bold', borderRight: '1px solid #ccc' }, headerClass: 'border-r-2 border-black', },
    { headerName: '61', field: 'total', minWidth: 70,  width: 100, cellStyle: { fontWeight: 'bold', borderRight: '1px solid #ccc' } , headerClass: 'border-r-2 border-black',}, 
    { headerName: '', field: 'blank1', minWidth: 60,  width: 100, cellStyle: { fontWeight: 'bold', borderRight: '1px solid #ccc' } , headerClass: 'border-r-2 border-black',}, 
    { headerName: '', field: 'blank2', minWidth: 60,  width: 120, cellStyle: { fontWeight: 'bold', }, headerClass: 'border-r-2 border-black', },
  ];

  const defaultColDef = {
    resizable: false,
    sortable: true,
    flex: 1,
    cellStyle: { borderRight: '1px solid #ccc', textAlign: 'center' },
    minWidth: 60,
  };

  return (
    <div className="ag-theme-alpine p-4" style={{ height: '100%', width: '100%', maxHeight: '400px', overflowY: 'auto' }}>
      <AgGridReact
        columnDefs={columnDefs}
        rowData={rowData}
        domLayout="autoHeight"
        defaultColDef={defaultColDef}
        suppressCellFocus={true}
      />
    </div>
  );
};

export default ScoreCard;
